function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import TextInput from './TextInput';
import Button from './Button';

import './WebSubscribeForUpdates.css';

var WebSubscribeForUpdates = function (_Component) {
  _inherits(WebSubscribeForUpdates, _Component);

  function WebSubscribeForUpdates(props) {
    _classCallCheck(this, WebSubscribeForUpdates);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleEmailChange = function (value) {
      _this.setState({
        email: value
      });
    };

    _this.handleEmailFocus = function () {
      _this.setState({
        messageVisible: true
      });
    };

    _this.handleSubscribeClick = function (e) {
      _this.form.submit();
    };

    _this.state = {
      email: '',
      messageVisible: false
    };
    return _this;
  }

  WebSubscribeForUpdates.prototype.getClassName = function getClassName() {
    var className = 'WebSubscribeForUpdates';

    if (this.props.className) {
      className = className + ' ' + this.props.className;
    }

    return className;
  };

  WebSubscribeForUpdates.prototype.getPrivacyPolicyLinkComponent = function getPrivacyPolicyLinkComponent() {
    if (this.props.privacyPolicyLinkComponent) {
      return this.props.privacyPolicyLinkComponent;
    }
    return 'Privacy Policy';
  };

  WebSubscribeForUpdates.prototype.getIntro = function getIntro() {
    if (this.props.intro) {
      return React.createElement(
        'div',
        { className: 'WebSubscribeForUpdates-intro' },
        this.props.intro
      );
    }
    return '';
  };

  WebSubscribeForUpdates.prototype.render = function render() {
    var _this2 = this;

    return React.createElement(
      'div',
      { className: this.getClassName() },
      React.createElement(
        'strong',
        null,
        'Subscribe for Updates'
      ),
      this.getIntro(),
      React.createElement(
        'div',
        { className: 'WebSubscribeForUpdates-form' },
        React.createElement(
          'form',
          { ref: function ref(form) {
              return _this2.form = form;
            }, action: this.props.mailchimpPostUrl, method: 'post', target: '_blank' },
          React.createElement(
            'div',
            { className: 'WebSubscribeForUpdates-email-container' },
            React.createElement(TextInput, { value: this.state.email, name: 'EMAIL', width: '100%', placeholder: 'Email address', ariaLabel: 'Email address', ariaRequired: 'true', onChange: this.handleEmailChange, onFocus: this.handleEmailFocus })
          ),
          React.createElement(
            'div',
            { className: 'WebSubscribeForUpdates-subscribe-button-container' },
            React.createElement(Button, { className: 'WebSubscribeForUpdates-subscribe-button', label: 'Subscribe', width: '100%', onClick: this.handleSubscribeClick })
          )
        )
      ),
      this.state.messageVisible && React.createElement(
        'div',
        { className: 'WebSubscribeForUpdates-message' },
        'Your personal information is used to subscribe you to our mailing list and will not be shared with third parties for other purposes. Your details are processed according to our ',
        this.getPrivacyPolicyLinkComponent(),
        '. You can unsubscribe at any time by clicking the link in the footer of our emails.'
      )
    );
  };

  return WebSubscribeForUpdates;
}(Component);

export default WebSubscribeForUpdates;